// removed by extract-text-webpack-plugin
module.exports = {"root":"percentage-bar--root--3HguJvTO","fill":"percentage-bar--fill--2AbCYN0-"};


//////////////////
// WEBPACK FOOTER
// ./components/percentage-bar/styles.css
// module id = ./components/percentage-bar/styles.css
// module chunks = 0